// extracted by mini-css-extract-plugin
export default {"footerSocialsWrapper":"_FooterSocials_footerSocialsWrapper__CXTz6"};